
export type TweetResponseReferencedTweetType = typeof TweetResponseReferencedTweetType[keyof typeof TweetResponseReferencedTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TweetResponseReferencedTweetType = {
  REPLIED_TO: 'REPLIED_TO',
  QUOTED: 'QUOTED',
  RETWEETED: 'RETWEETED',
} as const;
